import {isFeatureEnabled} from '@github-ui/feature-flags'

// Controls rendering the full merge status section on the bottom of Overview
export function isFullMergeboxEnabled() {
  return isFeatureEnabled('prs_overview_full_merge_status')
}
